import LikeMindfulMoment from './LikeMindfulMoment';

export default LikeMindfulMoment;
